import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=5d5b52be"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5b52be')) {
      api.createRecord('5d5b52be', component.options)
    } else {
      api.reload('5d5b52be', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=5d5b52be", function () {
      api.rerender('5d5b52be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/Sidebar.vue"
export default component.exports